import type { BadgeProps } from '@/shared/components/ui/badge'

import React from 'react'

import { Badge } from '@/shared/components/ui/badge'

import { PricingEngineType } from '../model/types'

type Props = BadgeProps & {
	engine?: PricingEngineType | string
}
export const getPcBadgeVariant = (
	engine?: PricingEngineType | string
): BadgeProps['variant'] => {
	switch (engine) {
		case PricingEngineType.RB:
			return 'warning'
		case PricingEngineType.MD:
			return 'epic'
		case PricingEngineType.ML:
			return 'info'
		case PricingEngineType.Promo:
			return 'success'
		default:
			return 'neutral'
	}
}
const EngineBadge = ({ className, children, engine, ...props }: Props) => (
	<Badge
		data-testid='engine-badge'
		size='sm'
		variant={getPcBadgeVariant(engine)}
		className={className}
		{...props}
	>
		{children}
	</Badge>
)

export default EngineBadge
